import JobGridType3Container from "../../../components/job/grid/JobGridType3";

const JobGridType3 = () => {
  return <JobGridType3Container />;
};

export default JobGridType3;
